import { Fragment } from 'react'
import { useTranslation } from 'react-i18next'

import { IconSpinner } from '../../Icon'
import Text from '../../Text'

import * as styles from './DocFlowSelectedAreaInfo.module.css'

function DocFlowSelectedAreaInfo({
  floatingStyles,
  getFloatingProps,
  infoItems,
  isOpen,
  isPdfFinishedRendering,
  loading,
  refs,
}) {
  const { t } = useTranslation()

  const { setFloating } = refs

  return isOpen && isPdfFinishedRendering ? (
    <div
      {...getFloatingProps()}
      className={styles.DocFlowSelectedAreaInfo}
      ref={setFloating}
      style={floatingStyles}
    >
      {loading || infoItems?.length === 0 ? (
        <div className={styles.noDataContainer}>
          {loading ? (
            <>
              <IconSpinner />
              <Text isSecondary>{t('Common.LoadingTextKey')}..</Text>
            </>
          ) : (
            <Text isSecondary>
              {t('DocumentStappling.SplittingAndMappingNoDataTextKey')}
            </Text>
          )}
        </div>
      ) : (
        <div className={styles.scrollContent}>
          <div className={styles.content}>
            {infoItems?.map(infoItem => (
              <Fragment key={infoItem.title}>
                <Text className={styles.title}>{infoItem.title}:</Text>
                <Text
                  className={styles.contentText}
                  isSecondary={!infoItem.text}
                >
                  {infoItem.text ||
                    t('DocumentStappling.SplittingAndMappingNoDataTextKey')}
                </Text>
              </Fragment>
            ))}
          </div>
        </div>
      )}
    </div>
  ) : null
}

export default DocFlowSelectedAreaInfo
